module.exports = __webpack_public_path__ + "static/SM400-ea3e4a1e361d974957a3a315e61c734e.png";